export const shareHouseholdOptions = [
  {
    value: '1',
    key: 'one',
  },
  {
    value: '1.5',
    key: 'one-and-a-half',
  },
  {
    value: '2',
    key: 'two',
  },
  {
    value: '2.5',
    key: 'two-and-a-half',
  },
  {
    value: '3',
    key: 'three',
  },
  {
    value: '4',
    key: 'four',
  },
  {
    value: '5',
    key: 'five',
  },
  {
    value: '6',
    key: 'six',
  },
] as const;

export const taxSavingSimulatorConstants = {
  householdAnnualIncome: {
    default: 50_000,
    max: 1_000_000_000,
  },
  taxSharesHousehold: {
    default: 1,
  },
};

// PER deduction ceiling ("plafond épargne retraite").
export const PER_DEDUCTION = {
  // PASS = Plafond Annuel de la Sécurité Sociale. The ceiling for a year-N
  // deposit uses the PASS of N-1, so a 2026 deposit uses PASS 2025. Update yearly.
  pass: 47_100, // 2025 (N-1 for 2026 deposits)
  rate: 0.1, // 10% of professional income, floored at 10% PASS, capped at 10% × 8 PASS.
  // Unused ceilings of the 3 previous years (N-1..N-3) carry over. A first-time
  // PER subscriber (the landing audience) has them all intact.
  reportYears: 3,
};

// Low-income rebate ("décote") applied to the income tax: reduces it by
// `threshold − rate × tax` when positive. 2026 figures (2025 income); both
// thresholds confirmed against impots.gouv. Reindex yearly like TAX_BRACKETS.
export const DECOTE = {
  rate: 0.4525,
  single: 897,
  couple: 1483,
};

// Family-quotient cap ("plafonnement du quotient familial"): the tax reduction
// from each half-part beyond the base (1 single / 2 couple) is capped at this
// amount. 2026 figure (2025 income); confirmed against impots.gouv. Reindex
// yearly like TAX_BRACKETS.
export const QUOTIENT_CAP_PER_HALF_PART = 1807;

// Tax below this amount is not collected ("seuil de mise en recouvrement",
// art. 1657 CGI). Applied to the final tax, after the décote.
export const TAX_RECOVERY_THRESHOLD = 61;

export const TAX_BRACKETS = [
  { min: 0, max: 11_600, rate: 0 },
  { min: 11_601, max: 29_579, rate: 0.11 },
  { min: 29_580, max: 84_577, rate: 0.3 },
  { min: 84_578, max: 181_917, rate: 0.41 },
  { min: 181_918, max: Infinity, rate: 0.45 },
];
